
import { Component, Vue, Prop, Watch } from "vue-property-decorator"

import { get, set } from "lodash"

// @ts-ignore
import DatePicker from "v-calendar/lib/components/date-picker.umd"
import vSelect from "vue-select"
import HelpIcon from "@/components/New/Page/PageComponents/HelpIcon.vue"

import { Getter, State } from "vuex-class"
import { TimeZone } from "@/types"
import { DateTime } from "luxon"
import { formatDateMixin } from "@/mixins/formatDateMixin"

@Component({
	components: {
		"help-icon": HelpIcon,
		"v-select": vSelect,
		"v-date-picker": DatePicker
	}
})
export default class DateTimezoneInfo extends Vue {
	@Prop()
	value!: string | Date | DateTime | null;

	@State displayTimezone!: TimeZone | null
	@State timeZones!: TimeZone[]
	@State tenantSettings!: { [key: string]: any} | null
	@Getter("getTenantTimezones") tenantTimezones!: TimeZone[]

	systemZoneName: string = "system" // This is for unit tests only. Do not change here.

	get tenantTimezonesLimited (): boolean {
		return this.tenantSettings &&
			this.tenantSettings["timeZones"] &&
			Array.isArray(this.tenantSettings["timeZones"]) &&
			this.tenantSettings["timeZones"].length > 0
	}

	get currentTimezone (): TimeZone | null {
		if (!this.displayDate) return null
		if (this.displayTimezone) return this.displayTimezone

		const system = this.displayDate.setZone(this.systemZoneName)
		const systemTimezone = this.timeZones.find(t => t.iana === system.zoneName)
		return systemTimezone || null
	}

	get displayDate (): DateTime | null {
		if (!this.value) return null

		if (typeof this.value === "string") {
			return DateTime.fromISO(this.value)
		} else if (this.value instanceof Date) {
			return DateTime.fromJSDate(this.value)
		} else if (this.value instanceof DateTime) {
			return this.value
		}

		return null
	}

	get timezoneInfoList (): { id: string, hoursOffset: number, date: string }[] {
		if (!this.displayDate) return []

		const system = this.displayDate.setZone(this.systemZoneName)
		const utc = this.displayDate.setZone("utc")

		const systemTimezone = this.timeZones.find(t => t.iana === system.zoneName)

		const otherTimezoneText = this.tenantTimezones
			.filter(t => t.iana !== system.zoneName)
			.map(t => ({
				timezone: t,
				date: this.displayDate!.setZone(t.iana)
			}))

		return [
			{
				id: systemTimezone ? systemTimezone.title : "Your PC time",
				hoursOffset: system.offset / 60,
				date: formatDateMixin.methods.dateToString(system)
			},
			{
				id: "UTC",
				hoursOffset: 0,
				date: formatDateMixin.methods.dateToString(utc)
			},
			...otherTimezoneText.map(t => ({
				id: t.timezone.title,
				hoursOffset: (t.date.offset / 60),
				date: formatDateMixin.methods.dateToString((t.date))
			}))
		]
	}
}

